import { Routes } from '@angular/router';
import { PublicGuard } from './core/guards/public/public.guard';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { NotFoundGuard } from './core/guards/not-found/not-found.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [PublicGuard],
    loadChildren: () =>
      import('./modules/auth/auth.routes').then((routes) => routes.authRoutes),
  },
  {
    path: 'modulos',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./modules/admin/pages/module-hub/module-hub.component').then(
        (m) => m.ModuleHubComponent
      ),
    title: 'Seleccionar Módulo',
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./modules/admin/admin.routes').then(
        (routes) => routes.adminRoutes
      ),
  },
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: '**',
    canActivate: [NotFoundGuard],
    loadComponent: () =>
      import('./modules/admin/pages/module-hub/module-hub.component').then(
        (m) => m.ModuleHubComponent
      ),
  },
];
